var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnlilLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6038 0L51.9317 0.0247232C49.175 0.0247232 46.536 1.12509 44.5846 3.06619L37.0889 10.5462H62.054L69.779 2.83747L72.6038 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9541 0.667664L73.9293 21.2965C73.9293 24.0474 72.8329 26.6809 70.8815 28.6282L63.3857 36.1082V11.1954L71.1107 3.48659L73.9541 0.667664Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3861 36.1082L42.7139 36.1329C39.9572 36.1329 37.3182 37.2271 35.3668 39.1744L27.8711 46.6544H52.8363L60.5612 38.9457L63.3861 36.1082Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.959 36.5595L64.9342 57.1883C64.9342 59.9393 63.8377 62.5727 61.8864 64.52L54.3906 72.0001V47.0872L62.1156 39.3784L64.959 36.5595Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.515 10.095L14.8428 10.1197C12.0861 10.1197 9.44712 11.2201 7.49575 13.1612L0 20.6412H24.9652L32.6901 12.9324L35.515 10.095Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0879 10.54L37.0631 31.1689C37.0631 33.9198 35.9667 36.5533 34.0153 38.5005L26.5195 45.9806V21.0677L34.2445 13.359L37.0879 10.54Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlilLogo);
export default __webpack_public_path__ + "static/media/enlil_logo.b26d3e788ea0e2a5d2e6a95cac6d08dc.svg";
export { ForwardRef as ReactComponent };